import React, { useState, useContext, useRef, useEffect } from 'react'
import gsap from 'gsap'
import NavigationBar from './components/NavigationBar/NavigationBar'
import Navigation from './components/Navigation/Navigation'
import Content from './components/HomeContent/HomeContent'
import Card from './components/Card/Card'
import githubImage from './assets/github-min.jpg'
import twitterImage from './assets/twitter-min.jpg'
import projectsImage from './assets/projects-min.jpg'
import ApplicationContext from './utility/ContextProvider'
import MobileContent from './components/MobileContent/MobileContent'
import './Application.scss'

function App() {
  const cursor = useRef(null)
  const cursorText = useRef(null)

  const [navigationOpen, setNavigationOpen] = useState(false)

  const { darkMode } = useContext(ApplicationContext)

  const onNavigationMenuButtonClick = (lineOne: any, lineTwo: any) => {
    setNavigationOpen((state) => {
      if (!state) {
        gsap.to(lineOne.current, 0.5, { rotate: 45, y: 3.5, background: darkMode ? '#050505' : '#e4e6eb' })
        gsap.to(lineTwo.current, 0.5, { rotate: -45, y: -3.5, background: darkMode ? '#050505' : '#e4e6eb' })
        cursor.current.style.background = darkMode ? '#000000' : '#e4e6eb'
        cursorText.current.style.color = darkMode ? '#e4e6eb' : '#000'
      } else {
        gsap.to(lineOne.current, 0.5, { rotate: 0, y: 0, background: darkMode ? '#e4e6eb' : '#050505' })
        gsap.to(lineTwo.current, 0.5, { rotate: 0, y: 0, background: darkMode ? '#e4e6eb' : '#050505' })
        cursor.current.style.background = darkMode ? '#e4e6eb' : '#000000'
        cursorText.current.style.color = darkMode ? '#000' : '#e4e6eb'
      }

      return !state
    })
  }

  useEffect(() => {
    const cursorFN = (e: any) => {
      cursor.current.style.top = e.pageY + 'px'
      cursor.current.style.left = e.pageX + 'px'
    }

    window.addEventListener('mousemove', cursorFN)

    return () => {
      window.removeEventListener('mousemove', cursorFN)
    }
  }, [])

  return (
    <div className={`app ${darkMode && 'app__dark'}`}>
      <div className='cursor' ref={cursor} style={{ background: darkMode ? '#e4e6eb' : '#000' }}>
        <p className='cursor__text' ref={cursorText} style={{ color: darkMode ? '#000' : '#e4e6eb' }}>
          Tap
        </p>
      </div>
      <div className='app__top'>
        <NavigationBar setNavigationOpen={onNavigationMenuButtonClick} navigationOpen={navigationOpen} />
        <Content cursor={cursor} cursorText={cursorText} />
        <Navigation navigationOpen={navigationOpen} />
      </div>
      <div className='app__bottom'>
        <Card
          image={githubImage}
          name='Github'
          text='Check me out on Github.'
          link='https://github.com/williamsimms'
          cursor={cursor}
          cursorText={cursorText}
        />
        <Card
          image={twitterImage}
          name='Twitter'
          text='Catch up with me on Twitter.'
          link='https://twitter.com/wijlum'
          cursor={cursor}
          cursorText={cursorText}
        />
        <Card
          image={projectsImage}
          name='Project'
          text='Check out my latest project.'
          link='https://facebook-63b89.web.app/'
          cursor={cursor}
          cursorText={cursorText}
        />
        <MobileContent />
      </div>
    </div>
  )
}

export default App
